import { CoreIcon } from '../core-icon';
import pinParkingColorSVG from '../../assets/icons/pin-parking-color.svg';
import type { IconProps } from '../core-icon';

export const PinParkingColorIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={pinParkingColorSVG} {...props} />;
};
